module.exports = __webpack_public_path__ + "617291ae031b52db603fc1c57b05e78b.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/movie-icons/icon_recruiting.gif
// module id = 693
// module chunks = 0